// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import gapi from 'vue-gapi'
import _ from 'lodash'
import { setupApiInterceptors, hasRoutePermission } from '@/http/auth'
// import '@mdi/font/css/materialdesignicons.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
setupApiInterceptors(axios)
Vue.prototype.$eventBus = new Vue()
Vue.prototype.lodash = _

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  } else { document.title = 'Revelio Planning' }

  // Allow public authentication and error landing routes
  if (to.path === '/op/tables/login' || to.path === '/op/tables/notice') {
    return next()
  }

  // Vuex is empty on F5 until MSAL + getUser finish. Do not treat a missing
  // role as "no permission" or users land on Maintenance Notice.
  const role = store.state.user && store.state.user.Role
  if (role == null || role === '') {
    return next()
  }

  if (!hasRoutePermission(store.state.user, to)) {
    return next('/op/tables/notice')
  }

  next()
})

const apiConfig = {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  clientId: '881270109259-uc4ir4867vdt23c0d4j05a0acb8asa93.apps.googleusercontent.com',
  discoveryDocs: ['https://people.googleapis.com/$discovery/rest?version=v1', 'https://www.googleapis.com/discovery/v1/apis/admin/directory_v1/rest'],
  scope: 'https://www.googleapis.com/auth/user.emails.read https://www.googleapis.com/auth/admin.directory.user.readonly https://www.googleapis.com/auth/admin.directory.group.member.readonly https://www.googleapis.com/auth/admin.directory.group.readonly'
}

Vue.use(gapi, apiConfig)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
